import { render, staticRenderFns } from "./FormMovimientoBancario.vue?vue&type=template&id=55283830&scoped=true&"
import script from "./FormMovimientoBancario.vue?vue&type=script&lang=js&"
export * from "./FormMovimientoBancario.vue?vue&type=script&lang=js&"
import style0 from "./FormMovimientoBancario.vue?vue&type=style&index=0&id=55283830&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55283830",
  null
  
)

export default component.exports